var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgChillTemp(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 90,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 72,
    height: 90,
    rx: 10,
    fill: "#14141D"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 36,
    cy: 45,
    r: 50,
    fill: "#181822"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 36,
    cy: 45,
    r: 40,
    fill: "#1F1F2D"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 36,
    cy: 45,
    r: 30,
    fill: "#272737"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 36,
    cy: 45,
    r: 20,
    fill: "#323246"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35 45c-7.855 0-8.873-8.207-8.99-11.047-.022-.535.414-.953.95-.953H43.04c.537 0 .972.423.95.959-.012.294-.034.646-.072 1.041M35 45h10.792a.5.5 0 0 1 .354.853l-1 1a.5.5 0 0 1-.353.147H27.208a.5.5 0 0 1-.354-.146l-1-1a.5.5 0 0 1 .353-.854h8.794Zm0 0c3.675 0 5.854-1.797 7.144-4m1.773-6H46a1 1 0 0 1 1 1v4a1 1 0 0 1-1 1h-3.855m1.773-6c-.157 1.63-.593 3.985-1.773 6",
    stroke: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m38.923 28.462-.581-.97a.615.615 0 0 1 .252-.866l.719-.36a.615.615 0 0 0 .283-.808L38 22M35 30.154l-.582-.969a.615.615 0 0 1 .253-.867l.718-.359a.615.615 0 0 0 .283-.808l-1.596-3.459M30.923 28.462l-.581-.97a.615.615 0 0 1 .252-.866l.719-.36a.615.615 0 0 0 .283-.808L30 22",
    stroke: "#fff",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.174 59.17h1.752a3.177 3.177 0 0 1-.474 1.53 2.829 2.829 0 0 1-1.166 1.042c-.497.25-1.094.375-1.793.375a3.67 3.67 0 0 1-1.471-.281 3.13 3.13 0 0 1-1.113-.82 3.654 3.654 0 0 1-.698-1.29 5.578 5.578 0 0 1-.24-1.693v-.592c0-.625.082-1.189.246-1.693.168-.508.407-.94.715-1.295a3.187 3.187 0 0 1 1.12-.82 3.56 3.56 0 0 1 1.452-.287c.711 0 1.31.129 1.8.386.491.258.872.614 1.142 1.067.273.453.437.969.492 1.547H29.18a2.262 2.262 0 0 0-.205-.873 1.164 1.164 0 0 0-.533-.545c-.235-.125-.547-.188-.938-.188-.293 0-.549.055-.767.164-.219.11-.402.276-.551.498a2.46 2.46 0 0 0-.334.844 5.84 5.84 0 0 0-.105 1.184v.603c0 .442.033.83.1 1.166.066.332.167.614.304.844.14.227.32.398.539.516.223.113.49.17.803.17.367 0 .67-.06.908-.176.238-.117.42-.291.545-.522.129-.23.205-.517.228-.861ZM33.862 53v9h-1.688v-9h1.688Zm-.24 5.607h-.464c.004-.441.063-.847.176-1.218.113-.375.276-.7.486-.973.212-.277.463-.492.756-.644.297-.153.625-.229.985-.229.312 0 .596.045.85.135.257.086.478.226.661.422.188.191.332.443.434.755.102.313.152.692.152 1.137V62H35.96v-4.02c0-.28-.04-.502-.123-.662a.678.678 0 0 0-.346-.345 1.282 1.282 0 0 0-.55-.106c-.242 0-.45.045-.621.135-.168.09-.303.215-.405.375-.101.156-.175.34-.222.55-.047.212-.07.438-.07.68Zm7.34-2.947V62H39.27v-6.34h1.694Zm-1.798-1.652c0-.246.086-.45.258-.61.172-.16.402-.24.691-.24.285 0 .514.08.686.24.176.16.264.364.264.61s-.088.449-.264.61c-.172.16-.4.24-.686.24-.289 0-.52-.08-.691-.24a.797.797 0 0 1-.258-.61ZM44.38 53v9h-1.694v-9h1.694Zm3.416 0v9H46.1v-9h1.694Z",
    fill: "#fff"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 72,
    height: 90,
    rx: 10,
    fill: "#fff"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChillTemp);
export default __webpack_public_path__ + "static/media/chillTemp.5d3176e7f93a65fc515d2c84c454bad1.svg";
export { ForwardRef as ReactComponent };